import FormattedMessage from 'I18n/components/FormattedMessage';
import { getTypeAction } from '../../utils/i18nUtils';
import { unreachableFallback } from 'ui-product-approvals-common/utils/unreachableFallback';
import { useApprovalContext } from '../../hooks/useApprovalContext';
import { jsx as _jsx } from "react/jsx-runtime";
export const ApprovalNotReadyI18nTitle = () => /*#__PURE__*/_jsx(FormattedMessage, {
  message: "productApprovals.ApprovalNotReady.title"
});
export const ApprovalNotReadyI18nFetching = () => /*#__PURE__*/_jsx(FormattedMessage, {
  message: "productApprovals.ApprovalNotReady.fetching"
});
export const ApprovalNotReadyI18nBody = () => {
  const {
    meta
  } = useApprovalContext();
  const {
    approvalAction,
    approvalType
  } = meta;
  const typeAction = getTypeAction(approvalType, approvalAction);
  switch (typeAction) {
    case 'MARKETING_EMAIL-PUBLISH':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalNotReady.MARKETING_EMAIL-PUBLISH.body"
        });
      }
    case 'LANDING_PAGE-PUBLISH':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalNotReady.LANDING_PAGE-PUBLISH.body"
        });
      }
    case 'SITE_PAGE-PUBLISH':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalNotReady.SITE_PAGE-PUBLISH.body"
        });
      }
    case 'BLOG_POST-PUBLISH':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalNotReady.BLOG_POST-PUBLISH.body"
        });
      }
    case 'DEAL-MOVE_STAGE':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalNotReady.DEAL-MOVE_STAGE.body"
        });
      }
    case 'KNOWLEDGE_ARTICLE-PUBLISH':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalNotReady.KNOWLEDGE_ARTICLE-PUBLISH.body"
        });
      }
    case 'QUOTE-PUBLISH':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalNotReady.QUOTE-PUBLISH.body"
        });
      }
    case 'SOCIAL_BROADCAST-PUBLISH':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalNotReady.SOCIAL_BROADCAST-PUBLISH.body"
        });
      }
    case 'CONNECTED_APP-INSTALL':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalNotReady.CONNECTED_APP-INSTALL.body"
        });
      }
    default:
      return unreachableFallback(typeAction, /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.unhandled.approvalType"
      }));
  }
};